import { NotificationTopic, NotificationTopicSchema } from '@sit/notifications-shared';
import { getTimesheetRoute } from '@web/containers/Timesheet/helpers/routes';
import { JSX } from 'react';
import { useNavigate } from 'react-router';
import { NotificationData } from './notification-data';
import DefaultNotification from './notification/DefaultNotification';
import DescriptionNotification from './notification/DescriptionNotification';

interface NotificationProps {
  notification: NotificationData;
}

const NotificationTile = ({ notification }: NotificationProps): JSX.Element | null => {
  const navigate = useNavigate();

  const { meta, metaId } = notification;
  const isTimesheetNotification =
    !!meta &&
    (
      [
        NotificationTopicSchema.enum.TIMESHEETS,
        NotificationTopicSchema.enum.SUBMIT_TIMESHEET,
        NotificationTopicSchema.enum.SAVE_TIMESHEET,
      ] as NotificationTopic[]
    ).includes(meta);
  const handleClick = () => {
    if (isTimesheetNotification && metaId) {
      return navigate(getTimesheetRoute(metaId));
    }

    if (meta === NotificationTopicSchema.enum.TIMESHEETS) {
      return navigate('/timesheets');
    }

    if (meta === NotificationTopicSchema.enum.DATA_SOURCES) {
      return navigate('/data-sources');
    }
  };

  if (isTimesheetNotification) {
    return <DescriptionNotification notification={notification} onClick={handleClick} />;
  }

  return <DefaultNotification notification={notification} onClick={handleClick} />;
};

export default NotificationTile;
